import styled from '@emotion/styled';

export const CardTitle = styled.div`
  margin-bottom: 15px;
  color: ${({ theme }) => theme.colors.midDarkGrey};
`;
